import {
    NARRATIVE_SEARCH_REQUEST,
    NARRATIVE_SEARCH_SUCCESS,
    NARRATIVE_SEARCH_FAILURE,
} from '../../../Constants/actionTypes';

import { narrative_search } from '../../../Constants/apiService'


// Action to start search
export const narrativeSearchRequest = () => ({
    type: NARRATIVE_SEARCH_REQUEST,
});

// Action when search is successful
export const narrativeSearchSuccess = (results) => ({
    type: NARRATIVE_SEARCH_SUCCESS,
    payload: results,
});

// Action when search fails
export const narrativeSearchFailure = (error) => ({
    type: NARRATIVE_SEARCH_FAILURE,
    payload: error,
});


export const narrativeSearch = (query) => {
    console.log(query)
    return async (dispatch, getState) => {
        dispatch(narrativeSearchRequest());

        const state = getState();
        const accessToken = state.auth.accessToken;

        try {

            const data = await narrative_search(accessToken, query);
            console.log(data)
            dispatch(narrativeSearchSuccess(data));

        } catch (error) {
            let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
            dispatch(narrativeSearchFailure(errorMessage));
        }


    };
};